<template>
	<div class="page-wrapper">
		<div class="page-breadcrumb d-flex justify-content-between">
			<h2 class="page-title"><i class="fas fa-chart-line"></i> Dashboard RoofCal</h2> 
		</div>
	</div>
</template>
<script>
export default {
  name: 'RoofCalDash'
};
</script>
<style scoped lang="scss">

</style>
